import { action } from "mobx";
import styled from "styled-components";
import { withViewState } from "../Context";
const SidePanelContainer = styled.div.attrs(_ref => {
  let {
    viewState
  } = _ref;
  return {
    className: viewState.topElement === "SidePanel" ? "top-element" : "",
    onClick: action(() => {
      viewState.topElement = "SidePanel";
    }),
    onTransitionEnd: () => viewState.triggerResizeEvent()
  };
}).withConfig({
  displayName: "SidePanelContainer",
  componentId: "sc-133gx1j-0"
})(["display:flex;flex-direction:column;position:absolute;left:", "px;top:", "px;height:calc(100% - 2 * ", "px);z-index:100;background:", ";backdrop-filter:", ";font-family:", "px;width:", "px;flex-basis:", "px;max-width:", "px;box-sizing:border-box;h1{margin:0;}transition:all 0.25s;transition-timing-function:cubic-bezier(0.4,0,0.2,1);visibility:", ";opacity:", ";margin-left:", ";border-radius:", ";"], p => p.theme.workbenchMargin, p => p.theme.workbenchMargin, p => p.theme.workbenchMargin, p => p.theme.transparentDark, p => p.theme.blur, p => p.theme.fontPop, p => p.theme.workbenchWidth, p => p.theme.workbenchWidth, p => p.theme.workbenchWidth, p => p.show ? "visible" : "hidden", p => p.show ? 1 : 0, p => p.show ? "0px" : "-".concat(p.theme.workbenchWidth, "px"), p => p.theme.radiusXL);
export default withViewState(SidePanelContainer);